export const onAppCloseEvent = "PubrAppClose";

export const appMountedBodyClasses = [
  "pubr--mounted",
  "pubr--mounted-complete",
];
